import { api } from '@/services/api/AxiosBaseService'
import type { PaginationMeta } from '@/types/api'

export interface IntegrationErrorLog {
  id: string
  integration: string
  context: string
  referenceType: string | null
  referenceId: string | null
  message: string
  payload: Record<string, unknown> | null
  createdAt: string | null
}

export const IntegrationErrorLogsService = {
  async list(params?: Record<string, unknown>): Promise<{ data: IntegrationErrorLog[]; meta: PaginationMeta }> {
    const r = await api.get<{ data: IntegrationErrorLog[]; meta: PaginationMeta }>('/integrations/error-logs', { params })
    return r.data
  },

  async remove(id: string): Promise<void> {
    await api.delete(`/integrations/error-logs/${id}`)
  },

  async clearAll(): Promise<{ deleted: number }> {
    const r = await api.delete<{ data: { deleted: number } }>('/integrations/error-logs')
    return r.data.data
  },
}
